module.exports = __webpack_public_path__ + "img/zztbg-4.e6bd1c1f.png";